import React from 'react'
import Lottie from 'lottie-react';
import "./Pdf_lottie_animation.css";
import animationData from './Pdf_lottie_animation.json';

function Pdf_lottie_animation ()  {
  return (
     <section className='Pdf_lottie_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="Pdf_lottie"
      />
    </section>
  )
}

export default Pdf_lottie_animation